import React from 'react';
import { useLocation } from 'react-router-dom';
import GeneradorForm from '../components/tabForms/GeneradorForm'
import { Container } from '@mui/material';

const GeneradorPage = () => {
    const location = useLocation();
    const { formData  } = location.state || {};  // Acceder a los datos del cliente

    return (
        <Container maxWidth="lg">
            {/* Pasar los datos del cliente como props al formulario */}
          {/*   <ProgressStepsComponent isAdmin={isAdmin} /> */}
            <GeneradorForm 
            //customer={formData.customer } 
           // clientData={formData}
            contractData={formData}
            />
        </Container>
    );
};

export default GeneradorPage;